import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const otpRequest = (dialCode, phoneno) => {
  return phoneno === '9876543210' ? { response: true } : { response: false };
};

const otpAuth = ({ dialCode, phoneno, otp }) => {
  return {
    token: 'xxxxxxxxxxxxxx.yyyyyyyyyy.zzzzzzzzzzzz',
  };
};

const mocks = {
  Query: {
    otpAuth: (_, { input }) => otpAuth(input),
  },
  Mutation: {
    otpRequest: (_, { dialCode, phoneno }) => otpRequest(dialCode, phoneno),
  },
};

export { resolvers, typeResolvers, mocks };
